module.exports = __webpack_public_path__ + "img/person_return.03b545fa.svg";